var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReportProject = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1667 14.1667C14.5424 14.1667 14.9027 14.0174 15.1684 13.7517C15.4341 13.4861 15.5833 13.1257 15.5833 12.75V5.66667C15.5833 5.29094 15.4341 4.93061 15.1684 4.66493C14.9027 4.39926 14.5424 4.25 14.1667 4.25H8.57083C8.33391 4.25232 8.10018 4.19518 7.89105 4.08381C7.68191 3.97244 7.50406 3.81039 7.37375 3.6125L6.8 2.7625C6.67101 2.56662 6.4954 2.40584 6.28894 2.29457C6.08248 2.18331 5.85162 2.12504 5.61708 2.125H2.83333C2.45761 2.125 2.09728 2.27426 1.8316 2.53993C1.56592 2.80561 1.41667 3.16594 1.41667 3.54167V12.75C1.41667 13.1257 1.56592 13.4861 1.8316 13.7517C2.09728 14.0174 2.45761 14.1667 2.83333 14.1667H14.1667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportProject);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/report-project.ddcd163a1275b3bb2a6a6884179af86b.svg";